export default __webpack_public_path__ + "/dist/images/marketplace.deb4e97ab46865bc2bc6516737f86b89.svg";